import type { ElementProps } from "../types";
import S from "./List.module.scss";

export const List = ({ template, innerRef }: ElementProps) => {
  if (template.type === "orderedList") {
    return (
      <ol
        className={S.listNumbers}
        contentEditable
        ref={(innerRef as React.RefObject<HTMLOListElement>) ?? undefined}
        dangerouslySetInnerHTML={{ __html: template.text }}
      ></ol>
    );
  }

  return (
    <ul
      className={S.listNumbers}
      contentEditable
      ref={(innerRef as React.RefObject<HTMLUListElement>) ?? undefined}
      dangerouslySetInnerHTML={{ __html: template.text }}
    ></ul>
  );
};
